var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import SimpleBar from 'simplebar-react';
import "simplebar/dist/simplebar.min.css";
import './ScrollViewImplementation.css';
import useActiveThemeVariation from '../../../../themes/hooks/UseActiveThemeVariation';
import AutoSizer from '../../../advanced/autoSizer/AutoSizerComponent';
import StackLayout from '../../stackLayout/StackLayoutComponent';
var ScrollViewImplementation = function (props) {
    var children = props.children;
    var activeThemeVariation = useActiveThemeVariation(props, function (x) { return x.layoutThemes.scrollView; });
    var alwaysShowScrollbar = activeThemeVariation.alwaysShowScrollbar;
    return (React.createElement(StackLayout, __assign({}, activeThemeVariation, { stretch: true }),
        React.createElement(AutoSizer, null, function (_a) {
            var height = _a.height, width = _a.width;
            return (React.createElement(SimpleBar, { style: { width: width, height: height }, autoHide: !alwaysShowScrollbar }, typeof children === 'function' ? function (params) { return children(__assign({ width: width, height: height }, params)); } : React.createElement("div", { style: { minHeight: height, width: width, display: 'flex', flexDirection: 'column' } }, children)));
        })));
};
export default ScrollViewImplementation;
//# sourceMappingURL=ScrollViewImplementation.js.map